import { AnimatedSpinner } from '../../../components/AnimatedSpinner'
import { Modal } from '../Modal/Modal'
import { CustomSelect } from '../Selects'
import { samplePrompt } from './utils'

interface ImageGenerationModalProps {
  open: boolean
  samplePrompts?: { label: string; value: string }[]
  onClose: () => void
  label?: string
  prompt: string
  onChangePrompt: React.ChangeEventHandler<
    HTMLTextAreaElement | HTMLSelectElement
  >
  onGenerate: React.MouseEventHandler<HTMLButtonElement>
  isGenerating?: boolean
  isSubmitting?: boolean
}

export function ImageGenerationModal({
  open,
  onClose,
  samplePrompts = samplePrompt,
  label = 'Select a sample prompt...',
  prompt,
  onChangePrompt,
  onGenerate,
  isGenerating,
  isSubmitting,
}: ImageGenerationModalProps) {
  const handleSelectChange = (_name: string, value: string) => {
    const syntheticEvent = {
      target: { value },
    } as React.ChangeEvent<HTMLSelectElement>
    onChangePrompt(syntheticEvent)
  }

  return (
    <Modal title="Image Generation" open={open} onClose={onClose}>
      <div className="p-4">
        <div className="w-1/2 mb-4">
          <CustomSelect
            options={[label, ...samplePrompts.map(p => p.label)]}
            selectedOption={
              samplePrompts.find(p => p.value === prompt)?.label || label
            }
            onSelectChange={(name, selectedLabel) => {
              const selectedPrompt = samplePrompts.find(
                p => p.label === selectedLabel,
              )

              handleSelectChange(name, selectedPrompt?.value || '')
            }}
            name="sample-prompts"
            clearable={false}
          />
        </div>

        <textarea
          value={prompt}
          onChange={onChangePrompt}
          placeholder="Prompt for image generation"
          rows={4}
          className="w-full px-3 py-2 tc-mv-question-field text-white rounded-2xl outline-none disabled:opacity-70 !resize-y no-scrollbar"
        />
        <div className="flex justify-end mt-4">
          <button
            type="submit"
            className="btn btn-small btn-black"
            onClick={onGenerate}
            disabled={!prompt.trim() || isSubmitting || isGenerating}
          >
            {isGenerating && <AnimatedSpinner className="mr-2" />}
            Generate
          </button>
        </div>
      </div>
    </Modal>
  )
}
